import PostAddForm from "./post-add-form";

export default PostAddForm;